import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { restoreCabinet } from 'containers/Configurator/actions/furniture';
import { Color } from 'lib/modelBuilder/entities/Color';
import { Cabinet } from 'lib/modelBuilder/entities/Cabinet';
import { createStructuredSelector } from 'reselect';
import { RootState } from 'containers/PanesPanel/types';
import { makeSelectLastHistoryCabinet } from 'containers/Configurator/selectors/history';
import ColorPickerList from 'components/ColorPickerList';
import { updateDrawersAction } from 'containers/DrawersPanel/actions';
import { useTranslation } from 'react-i18next';
import { setColorsPanelAction } from 'containers/Configurator/actions/general';
import { PickerTitleCategory } from '../../components/PickerTitleCategory';
import { makeSelectColors } from '../Configurator/selectors/colors';
import {
  ECO_COLOR,
  ECO_PLUS_COLOR,
  PaneMaterial,
} from '../../lib/modelBuilder/constants';

interface StateProps {
  colors: Color[];
  lastHistoryCabinet: Cabinet;
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  colors: makeSelectColors(),
  lastHistoryCabinet: makeSelectLastHistoryCabinet(),
});

const DrawersColorsPicker = () => {
  const dispatch = useDispatch();
  const { colors, lastHistoryCabinet } = useSelector(stateSelector);
  const { t } = useTranslation();

  const colorSelected = (color: Color, preview: boolean) => {
    dispatch(updateDrawersAction(color, preview));
  };

  const onClickItem = (color: Color) => {
    colorSelected(color, false);
  };

  const onMouseOverItem = (color: Color) => {
    colorSelected(color, true);
  };

  const onLeave = () => {
    // Restore the last history element
    dispatch(restoreCabinet(lastHistoryCabinet));
  };

  return (
    <div className="mx-2 px-2">
      <div className="flex bg-gray-300">
        <PickerTitleCategory selected>{t('Colors')}</PickerTitleCategory>
      </div>
      {colors && (
        <div onMouseLeave={onLeave}>
          <ColorPickerList
            colors={colors.filter(
              color =>
                (color.material === PaneMaterial.MDF ||
                  color.material === PaneMaterial.Alu) &&
                color.reference !== ECO_COLOR &&
                color.reference !== ECO_PLUS_COLOR,
            )}
            onClick={onClickItem}
            onMouseOver={onMouseOverItem}
            onDoubleClick={() => {
              dispatch(setColorsPanelAction());
            }}
            bigColors={[]}
          />
        </div>
      )}
    </div>
  );
};

export default DrawersColorsPicker;
